import React from 'react';
import { Link } from 'react-router-dom';
import Header from '../components/Header';
import Footer from '../components/Footer';

const ContactPage: React.FC = () => {
  return (
    <div className="min-h-screen flex flex-col bg-gradient-to-br from-indigo-50 via-violet-50 to-amber-50 pt-24 pb-20">
      <Header />
      <div className="flex-1 w-full px-4 max-w-7xl mx-auto">
        <div className="flex flex-col md:flex-row justify-between items-start md:items-center gap-4 mb-10">
          <div>
            <h1 className="text-4xl md:text-5xl font-bold text-slate-900 mb-4">Get in Touch</h1>
            <p className="text-lg text-slate-700 max-w-2xl">Reach out to NovaTrust for onboarding, scheme guidance or any questions about your chit fund journey.</p>
          </div>
          <Link to="/" className="inline-flex items-center px-6 py-3 rounded-full bg-gradient-to-r from-amber-400 via-amber-500 to-yellow-400 text-slate-950 font-semibold shadow-lg hover:from-amber-500 hover:to-yellow-500 transition">
            Back Home
          </Link>
        </div>

        <div className="rounded-3xl bg-white p-8 shadow-xl border border-slate-200">
          <form action="https://formsubmit.co/info@novatrust.co.in" method="POST" className="space-y-6">
            <input type="hidden" name="_captcha" value="false" />
            <input type="hidden" name="_template" value="table" />
            <input type="hidden" name="_subject" value="New Contact Lead From NovaTrust Website" />
            <input type="hidden" name="_redirect" value="https://novatrust.co.in/" />

            <div className="grid gap-6 md:grid-cols-2">
              <label className="block">
                <span className="text-sm font-semibold text-slate-700">Name</span>
                <input name="name" className="mt-2 w-full rounded-2xl border border-slate-200 px-4 py-3 focus:ring-2 focus:ring-blue-300 outline-none" placeholder="Your full name" required />
              </label>
              <label className="block">
                <span className="text-sm font-semibold text-slate-700">Email</span>
                <input name="email" type="email" className="mt-2 w-full rounded-2xl border border-slate-200 px-4 py-3 focus:ring-2 focus:ring-blue-300 outline-none" placeholder="name@example.com" required />
              </label>
            </div>

            <div className="grid gap-6 md:grid-cols-2">
              <label className="block">
                <span className="text-sm font-semibold text-slate-700">Phone Number</span>
                <input name="phone" type="tel" className="mt-2 w-full rounded-2xl border border-slate-200 px-4 py-3 focus:ring-2 focus:ring-blue-300 outline-none" placeholder="+91 XXXXX XXXXX" required />
              </label>
              <label className="block">
                <span className="text-sm font-semibold text-slate-700">Subject</span>
                <input name="subject" className="mt-2 w-full rounded-2xl border border-slate-200 px-4 py-3 focus:ring-2 focus:ring-blue-300 outline-none" placeholder="What can we help you with?" required />
              </label>
            </div>

            <label className="block">
              <span className="text-sm font-semibold text-slate-700">Message</span>
              <textarea name="message" className="mt-2 w-full min-h-[170px] rounded-3xl border border-slate-200 px-4 py-4 focus:ring-2 focus:ring-blue-300 outline-none" placeholder="Tell us what you need." required />
            </label>

            <button type="submit" className="w-full rounded-full bg-blue-600 text-white font-semibold py-3 hover:bg-blue-700 transition">Send Message</button>
          </form>
        </div>
      </div>
      <Footer />
    </div>
  );
};

export default ContactPage;
